export enum FiatReplenishGatewayProvider {
  'SIMULATED',
  'MANUAL'
}

export enum FiatReplenishGatewayProviderFailReason {
  'MANUAL_ORDER_FAILED'
}
